import {
    PRODUCT_ANALYTICS_POPULATE,
} from '../../constants/types';



export const INITIAL_STATE = [
{
    
        "inventory_chart": {
          "series": [
            {
              "data": [
                
              ],
              "type": "column",
              "name": "Value",
              "showInLegend": true
            },
            {
              "data": [
                
              ],
              "type": "column",
              "name": "Qty",
              "showInLegend": true
            }
          ],
          "categories": [
            "Mon",
            "Tue",
            "Wed",
            "Thu",
            "Fri",
            "Sat",
            "Sun"
          ]
        },
        "inventory_details": {
          "keys": [
            "name/barcode",
            "qty",
            "inventory_value",
            "cost",
            "price",
            "margin"
          ],
          "header": [
            "Product/Barcode",
            "Qty",
            "Inventory Values",
            "Cost",
            "Price",
            "Margin"
          ],
          "data": {
            "headers": [
              "",
              "Current",
              "Change",
              "Current",
              "Change",
              "Current"
            ],
            "topHeaders": [
              
            ],
            "values": [
              
            ]
          }
        },
        "po_inventory_value": {
          "header": "Inventory Value",
          "data": {
            
          },
          "original_value": "N/A",
          "value": "N/A",
          "text": ""
        },
        "inventory_value": {
          "header": "Inventory Value",
          "data": {
            
          },
          "original_value": "N/A",
          "value": "N/A",
          "text": ""
        },
        "coverage": {
          "header": "Coverage",
          "data": {
            
          },
          "original_value": "N/A",
          "value": "N/A",
          "text": ""
        },
        "po_inventory_qty": {
          "header": "Ivnentory Qty",
          "data": {
            
          },
          "original_value": "N/A",
          "value": "N/A",
          "text": ""
        },
        "location": null
      
    
}
]
  

export const Reducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case PRODUCT_ANALYTICS_POPULATE:
            return [   ...action.payload ];
        default:
            return state
    }
}




// WEBPACK FOOTER //
// ./src/modules/productAnalytics/ProductAnalyticsReducers.js